module.exports = __webpack_public_path__ + "static/media/resource-4.a2eb2acb.png";